{
  "title": "Billing",
  "notVisibleTitle": "Billing is not visible to you",
  "notVisibleBody": "Subscription details are shown to tenant administrators and above.",
  "loadError": "Could not load billing",
  "notConnectedTitle": "Billing is not connected",
  "notConnectedBody": "This deployment has no Stripe credentials. Set Stripe:SecretKey and at least one Price id on the API to enable subscriptions.",
  "checkoutCompleteTitle": "Checkout completed",
  "checkoutCompleteBody": "Waiting for Stripe to confirm the subscription…",
  "checkoutCompleteToast": "Checkout complete. Stripe is confirming the subscription.",
  "checkoutCancelledToast": "Checkout was cancelled. Nothing has been charged.",
  "noSubscriptionTitle": "No subscription",
  "noSubscriptionBody": "This tenant is not being billed yet. A subscription charges one seat per mailbox the platform stamps.",
  "noSubscriptionConfirming": "Stripe is confirming the subscription. This page updates itself as soon as it does.",
  "startSubscription": "Start a subscription",
  "setupBilling": "Set up billing",
  "subscription": "Subscription",
  "plan": "Plan",
  "seats": "Seats",
  "billedSeats": "Billed seats",
  "liveSeats": "Live seats",
  "seatsValue": "billed {{billed}} / current {{current}}",
  "outOfSync": "out of sync",
  "syncSeats": "Sync seats",
  "seatsSynced": "Seats synced: billing {{count}}.",
  "seatSyncFailed": "Seat sync failed.",
  "openPortal": "Open customer portal",
  "manageInStripe": "Manage billing in Stripe",
  "portalOpenFailed": "Could not open the billing portal.",
  "cancelAtPeriodEnd": "Cancel at period end",
  "resume": "Resume",
  "resumeSubscription": "Resume subscription",
  "collectionCard": "Card — charged automatically",
  "collectionInvoice": "Invoice — emailed with net terms",
  "collectionInvoiceNet": "Invoice — emailed with net terms (net {{days}} days)",
  "statusNone": "No subscription",
  "statusIncomplete": "Incomplete",
  "statusExpired": "Expired",
  "statusTrialing": "Trialing",
  "statusActive": "Active",
  "statusPastDue": "Past due",
  "statusCanceled": "Canceled",
  "statusUnpaid": "Unpaid",
  "statusPaused": "Paused",
  "setupTitle": "Set up billing",
  "setupIntro": "Packages match Exclaimer's Starter / Standard / Pro layout and pricing. One seat per mailbox this tenant has the platform stamp — {{seats}} today{{minimum}}; the count is reconciled nightly and changes bill on the following invoice.",
  "setupMinimumSuffix": ", billed at the {{minimum}}-seat minimum",
  "periodMonthly": "Monthly",
  "periodAnnual": "Annual",
  "billedAnnually": "Billed annually",
  "billedAnnuallySave": "Billed annually (save {{percent}}%)",
  "billedMonthly": "Billed monthly",
  "savePercent": "Save {{percent}}%",
  "planSeatRate": "{{name}} ({{rate}}/seat/mo)",
  "planStarter": "Starter",
  "planStandard": "Standard",
  "planPro": "Pro",
  "enterpriseAvailable": " Enterprise (custom quote) is available via sales.",
  "licensedBlocks": "Licensed in blocks from {{minimum}} seats — a smaller tenant is billed for {{minimum}}. ",
  "noTrialReturning": "This tenant has subscribed before, so no trial applies.",
  "trialDays": "First {{days}} days free; the first invoice is raised when the trial ends.",
  "payByCard": "Pay by card",
  "invoiceCustomer": "Invoice the customer",
  "methodCard": "Card",
  "methodInvoice": "Invoice",
  "methodCardHint": "Opens Stripe Checkout to capture a card. Stripe charges it each period and the customer manages it themselves.",
  "methodInvoiceHint": "Stripe emails an invoice each period with net terms. No card is captured.",
  "billingEmail": "Billing email",
  "billingEmailHint": "Where Stripe sends invoices and receipts.",
  "billingEmailPlaceholder": "accounts@customer.com.au",
  "invoiceDueDays": "Invoice due in (days)",
  "setupFailed": "Could not set up billing",
  "continueToStripe": "Continue to Stripe",
  "createSubscription": "Create subscription",
  "subscriptionCreated": "Subscription created. Stripe will email invoices to {{email}}.",
  "cancelTitle": "Cancel at period end",
  "cancelBody": "The subscription stays active until the current period ends, then will not renew.",
  "cancelBodyDetailed": "Billing stops at the end of the paid period{{onDate}}. Signatures keep being stamped until then, and nothing is refunded or charged today.",
  "cancelOnDate": " on {{date}}",
  "confirmCancel": "Confirm cancel",
  "resumeBody": "The subscription will renew as normal again.",
  "updateFailed": "Could not update the subscription",
  "resumedToast": "Subscription resumed.",
  "cancelScheduledToast": "Subscription will end at the end of the period.",
  "paymentOverdueTitle": "Payment overdue",
  "paymentOverdueBody": "Stripe has not been able to collect the latest invoice. Signatures keep being stamped — nothing stops automatically — but the account needs attention.",
  "scheduledCancelTitle": "Scheduled to cancel",
  "scheduledCancelBody": "This subscription ends on {{date}} and will not renew.",
  "scheduledCancelFallbackDate": "the end of the current period",
  "billingLabel": "Billing",
  "invoicesGoTo": "Invoices go to",
  "notSet": "Not set",
  "price": "Price",
  "ends": "Ends",
  "renews": "Renews",
  "seatsLastSynced": "Seats last synced",
  "manage": "Manage",
  "manageHint": "Cards, invoices and receipts live in Stripe. Seats are reconciled here every night, and a change takes effect on the next invoice rather than part-way through this one.",
  "mspOnlyHint": "Changing or cancelling the subscription is done by OnBrand Mail staff."
}
